function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.82 24H1.32C.6 24 0 23.4 0 22.68V1.32C0 .6.6 0 1.32 0h21.36C23.4 0 24 .6 24 1.32v21.36c0 .73-.6 1.32-1.32 1.32h-6.12v-9.3h3.12l.47-3.62h-3.59V8.77c0-1.05.29-1.76 1.8-1.76h1.91V3.77c-.33-.05-1.47-.15-2.8-.15-2.76 0-4.65 1.7-4.65 4.8v2.66H9.69v3.63h3.13V24z"
}));